import {useAppLoading} from "@/hooks/useAppLoading";
import {onMounted} from "vue";
import {GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import {usePostMessage} from "@/hooks/web/usePostMessage";
import {useGlobalUserInfoStore} from "@/stores/global-user-info";
import {usePcSpaceStore} from "@/store/pcSpaceStore";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import {RoleEnum} from "@/enums/roleEnum";
import {CurrentUtils, getSystemConfigObj} from "xmgoing-server";
import {getFileConfigsFromDb, getRoleAppConfigs} from "@/api/sys/portalSpace";
import eventBus from "@/events/eventBus";
import GoingUtils from "@/utils/goingUtils";


/**
 * 获取附件的配置信息
 * @param backFun
 */
const getFileConfigsFun = async function (backFun) {
  const fileConfigsJsonStr = StorageUtils.getSessionItem("fileConfigsJson");
  if (fileConfigsJsonStr) {
    try {
      backFun && backFun(JSON.parse(fileConfigsJsonStr));
    } catch (e) {
      StorageUtils.removeSessionItem("fileConfigsJson");
      getFileConfigsFun(backFun);
    }
  } else {
    const fileConfigs = await getFileConfigsFromDb();
    backFun && backFun(fileConfigs);
    StorageUtils.addSessionItem("fileConfigsJson",JSON.stringify(fileConfigs));
  }
}

export function useAppLoad(locale, showType,fileConfigs,showPageFlag,roleAppConfigs) {

  const devFlag=ref(false);
  const pageWaterFlagVal=ref(false);
  let loadFileTimer: any = null;

  //loading信息 以及显示loading的标志
  const {loadingFlag, showLoading, hideLoading} = useAppLoading();

  if(window.appObj){
    window.appObj.analysisSet = false;
    window.appObj.showLoadingFun = showLoading;
    window.appObj.hideLoadingFun = hideLoading;
  }
  window.showLoadingFun = showLoading;
  window.hideLoadingFun = hideLoading;
  window.appObj.preview = true;

  const GlobalUserInfoStore = useGlobalUserInfoStore()
  const {
    refreshUserInfo
  } = GlobalUserInfoStore


  const pcSpaceStore = usePcSpaceStore();
  const pageModelsStore = usePageModelsStore();
  const dataSourceStore = useDataSourceStore();
  const routerObj = useRouter();

  onMounted(() => {
    const userJson = JSON.parse(StorageUtils.getSessionItem('curUserJson') + '');
    //心跳查询
    dataSourceStore.startPageHeart(dataSourceStore.startPageHeart);
    const url = window.location.href;
    //如果是刚登录进系统 则需要重新定向系统 否则会有敏感信息
    if (url.indexOf('userId=') >= 0) {
      routerObj.push({path: '/dashboard/analysis'});
      StorageUtils.addSessionItem('runningShow', true);
    }


    StorageUtils.removeSessionItem('scenario');
    const {initPageMsg} = usePostMessage();
    initPageMsg();
    refreshUserInfo();
    locale.value = (StorageUtils.getSessionItem("projectI18n") || StorageUtils.getItem("projectI18n")) === "en" ? enUS : zhCN;
    try {
      const {xmIntegrationFlag,pageWaterFlag} = getSystemConfigObj();
      StorageUtils.addSessionItem("pageWaterFlagVal",GoingNewUtils.parseBoolean(pageWaterFlag));
      //延时 避免影响性能
      setTimeout(()=>{
        pageWaterFlagVal.value=GoingNewUtils.parseBoolean(pageWaterFlag);
      },200);
    } catch (e) {
    }
    //如果是应用预览 模版 预览 则不需要进行查询操作
    if (unref(showType) !== 'app' && unref(showType) !== 'template') {
      const {closeUnitSpaceSel,closeUserSpaceSel} = getSystemConfigObj();
      if (userJson.position === 'system') {
        pcSpaceStore.loadingFlag=false;
        return;
      }
      //如果是管理员而且又是关闭closeUnitSpaceSel 则直接返回
      if (userJson.position === RoleEnum.USER_UNIT_ROLE && GoingNewUtils.parseBoolean(closeUnitSpaceSel)) {
        pcSpaceStore.loadingFlag=false;
        return;
      }
      //如果是普通用户
      if (userJson.position === RoleEnum.USER_ROLE && GoingNewUtils.parseBoolean(closeUserSpaceSel)) {
        pcSpaceStore.loadingFlag=false;
        return;
      }
      //获取首页信息
      pcSpaceStore.getSpaceItemsAction(dataSourceStore, pageModelsStore, unref(showType));
    }

    setTimeout(()=>{
      CurrentUtils.checkUserRole((res)=>{
        devFlag.value=res;
        StorageUtils.addSessionItem('devFlag',unref(devFlag))
      });
    },1000)
  });

  const loadFileConfigs = function () {
    if (unref(fileConfigs) === '') {
      getFileConfigsFun((sysConfig) => {
        fileConfigs.value = sysConfig;
      });
    }
  }

  /**
   * 获取角色应用配置信息
   */
  const loadRoleAppConfigs=async function (){
    if(GoingUtils.isMesSystem){
      const configs = await getRoleAppConfigs();
      roleAppConfigs.value=configs;
    }
  }

  const _clearAllKeepAliveCache=({}) => {
    showPageFlag.value=!showPageFlag.value;
    setTimeout(()=>{
      showPageFlag.value=true;
    })
  }

  onMounted(() => {
    //获取附件配置信息
    loadFileConfigs();
    //获取角色应用授权
    loadRoleAppConfigs();
    eventBus.off('clearAllKeepAliveCache',_clearAllKeepAliveCache);
    eventBus.on('clearAllKeepAliveCache',_clearAllKeepAliveCache);
  })

  onBeforeUnmount(()=>{
    eventBus.off('clearAllKeepAliveCache',_clearAllKeepAliveCache);
    // 清理定时器
    if (loadFileTimer) {
      clearTimeout(loadFileTimer);
      loadFileTimer = null;
    }
  })

  return {
    pageWaterFlagVal,
    devFlag,
    loadingFlag
  }
}
